module.exports = __webpack_public_path__ + "img/instructor_img7.39df2c15.png";